import { Link } from 'react-router-dom';
import { BILLING_UPGRADE_PATH } from '../lib/upgrade';
import { cn, ui } from '../lib/ui';

/**
 * Shown in place of a feature the organization's plan does not include
 * (docs/Decisions.md D52 item 4: premium features stay visible on every plan
 * and link to the billing upgrade flow). An org admin gets the link; anyone
 * else is told who can upgrade.
 */
export default function UpgradeNotice({ what, isOrgAdmin = false, headingLevel = 'h1' }) {
  const Heading = headingLevel;
  return (
    <section className={cn(ui.cardFlat, 'bg-dcon-accent-soft!')} aria-labelledby="upgrade-title">
      <p className="mb-2">
        <span className={ui.pillPremium}>Premium</span>
      </p>
      <Heading id="upgrade-title" className={ui.h2}>
        {what} is not part of this organization&apos;s plan
      </Heading>
      <p className="mb-4 text-body-s text-dcon-ink-body">
        {isOrgAdmin
          ? 'Upgrade the plan to turn it on for every member.'
          : 'Ask an organization admin to upgrade the plan.'}
      </p>
      {isOrgAdmin ? (
        <Link className={cn(ui.btnAccent, ui.btnSm)} to={BILLING_UPGRADE_PATH}>
          See plans and upgrade
        </Link>
      ) : null}
    </section>
  );
}
